// Temporary eslint override until this is productized:
// eslint-disable-next-line no-restricted-imports
import { getBucket } from '@mc/experiments'
import { EventTypes, track, trackKeyGrowthEvent } from '@mc/track-event'

import { LOCATION_RELATED_COURSES } from 'components/GlobalCarousel/events'
import {
  MEMBERS_ALSO_LIKED_EXP_FLAG,
  MEMBERS_ALSO_LIKED_EXP_PIXEL_FLAG,
} from './constants'

export const trackRelatedCoursesCarouselViewed = () =>
  trackKeyGrowthEvent(EventTypes.COURSE_MARKETING_PAGE_ROW_VIEWED, {
    category: 'explore-class-catalog',
    row_name: LOCATION_RELATED_COURSES,
  })

export const trackPixelExperimentViewed = () => {
  const variationName = getBucket(MEMBERS_ALSO_LIKED_EXP_FLAG)

  if (variationName) {
    track(EventTypes.EXPERIMENT_VIEWED, {
      experimentName: MEMBERS_ALSO_LIKED_EXP_PIXEL_FLAG,
      variationName,
    })
  }
}
